export default "__VITE_ASSET__DfBmS8cs__"